<!--我的订单-->
<template>
  <div class="home-main myOrder">
    <div class="main" v-loading="loading">
      <div class="main_title">
        <span class="title-cn">我的订单</span>
        <span class="title-en">/My Order</span>
      </div>
      <!--筛选部分start-->
      <div class="myOrder1-selector">
        <div>
          <div class="select-item">
            <p>下单时间</p>
            <el-date-picker value-format="yyyy-MM-dd" v-model="selectOrderDateStart" type="date" align="right"
              :picker-options="pickerOptions1" size="small">
            </el-date-picker>
            <span class="demonstration">到</span>
            <el-date-picker value-format="yyyy-MM-dd" v-model="selectOrderDateEnd" type="date" align="right"
              :picker-options="pickerOptions2" size="small">
            </el-date-picker>
          </div>
          <div class="select-item">
            <p>授权码</p>
            <el-input v-model="authCode" class="select-input" size="small" clearable></el-input>
          </div>
          <div class="select-item">
            <p>客户名称</p>
            <el-input v-model="custom_name" class="select-input" size="small" clearable></el-input>
          </div>
          <div class="select-item">
            <p>订单号</p>
            <el-input v-model="order_code" class="select-input" size="small" clearable></el-input>
          </div>
          <div class="select-item selcet-product">
            <p>类型</p>
            <!-- <el-input v-model="product" class="select-input" size="small" clearable></el-input> -->
            <el-select style="width: 150px !important" v-model="product" size="small" placeholder="请选择" clearable="">
              <el-option v-for="(item, key) in expenseType" :key="key" :label="item.name" :value="item.value"> </el-option>
            </el-select>
          </div>
        </div>

        <el-button size="small" class="warning" @click="search">搜索</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
      </div>
      <!--筛选部分end-->

      <div class="myOrder-main-line"></div>

      <!--订单列表start-->
      <div class="myOrder-main-list">
        <el-table @row-click="tableRowClick" height="100%" :data="tableData" style="width: 100%;" stripe>
          <el-table-column width="40"> </el-table-column>
          <el-table-column label="订单号">
            <template slot-scope="scope">
              <span>{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <span>{{ scope.row.product }}</span>
            </template>
          </el-table-column>
          <el-table-column label="明细">
            <template slot-scope="scope">
              <span>{{ scope.row.detail_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="时长">
            <template slot-scope="scope">
              <span>{{ scope.row.show_exprie_time }}</span>
            </template>
          </el-table-column>
          <el-table-column label="价格">
            <template slot-scope="scope">
              <span>{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="授权码">
            <template slot-scope="scope">
              <span>{{ scope.row.auth_code }}</span>
            </template>
          </el-table-column>
          <el-table-column label="下单时间">
            <template slot-scope="scope">
              <span>{{ scope.row.pay_time }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <span>{{ scope.row.orderComment }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--订单列表end-->
      <div class="pagination">
        <el-pagination :disabled="!pagination.use" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[20, 30, 50, 100]" :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
    </div>

    <!--产品加点弹窗start-->
    <el-dialog title="订单详细" :visible.sync="rowDetailDialog" width="600px">
      <el-table :data="rowDetail" border style="width: 100%">
        <el-table-column v-for="(item, key) in rowDetailConfig" :key="key" :prop="key" :label="item">
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--产品加点弹窗end-->
  </div>
</template>

<script>
import { getOrderByParam, getOrderByID } from "@/api/order";
import { createGetUrlParams } from "@/utils/url";
export default {
  data() {
    return {
      /*筛选条件-产品start*/
      loading: false,
      selectmyOrdersValue: "",
      authCode: "", //授权码
      custom_name: "", // 客户名称
      order_code: "",
      product: "",

      pagination: {
        use: true,
        total: 0,
        size: 20,
        currentPage: 1,
      },
      expenseType:[
        {
          "name":"FastBI",
          "value":"1",
        },
        {
          "name":"套件",
          "value":"3",
        },
        {
          "name":"加密狗",
          "value":"5",
        },
        {
          "name":"模块",
          "value":"6",
        },
        {
          "name":"小智报表",
          "value":"10",
        },
        {
          "name":"安捷云",
          "value":"20",
        },
        {
          "name":"安捷云模块",
          "value":"21",
        },
        {
          "name":"AF本地应用",
          "value":"22",
        },
      ],
      selectmyOrders: [
        {
          selectmyOrdersValue: "选项1",
          label: "FastBI产品",
        },
        {
          selectmyOrdersValue: "选项2",
          label: "C9开发版",
        },
        {
          selectmyOrdersValue: "选项3",
          label: "C9标准版",
        },
        {
          selectmyOrdersValue: "选项4",
          label: "C9高级版",
        },
      ],
      /*筛选条件-产品end*/

      /*筛选条件-下单时间start*/
      selectOrderDateStart: "", //选择下单时间-开始
      selectOrderDateEnd: "", //选择下单时间-结束
      pickerOptions1: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 1);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近7天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近1年",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      /*筛选条件-下单时间end*/

      /*表格数据start*/
      tableData: [],
      /*表格数据end*/
      rowDetailConfig: {},
      rowDetail: [], //行数据-详细
      rowDetailDialog: false,
    };
  },
  mounted() {
    this.getOrderData();
  },
  methods: {
    tableRowClick(row, event, column) {
      let flag = true;
      // this.loading = true
      let response = row;
      console.log(row);
      // getOrderByID(row.id).then(response=>{
      //   console.log(response,'response');
      switch (response.product) {
        case "加密狗": //加密狗
          this.rowDetailConfig = {
            name: "收件人",
            phone: "联系电话",
            address: "收件地址",
            note: "备注",
          };
          this.rowDetail[0] = response.dongle;
          break;
        case "人工服务": //人工服务
          this.rowDetailConfig = {
            name: "客户名称",
            days: "天数",
            type: "服务人员类型",
            note: "备注",
          };
          //response.staff_service.type = serviceStaffType[response.staff_service.type]
          this.rowDetail[0] = response.staff_service;
          break;
        case "套件": //套件
          this.rowDetailConfig = {
            auth_code: "绑定授权码",
            auth_name: "客户名称",
            suit_name: "套件名",
            suit_version: "版本",
          };
          this.rowDetail[0] = response.suit_auth;
          break;
        case "FastBI": //fastbi
          row.year = row.months / 12;
          row.year = row.year >= 100 ? "买断" : row.year + "年";
          row.edition = response.auth.edition;

          this.rowDetailConfig = {
            auth_code: "授权码",
            edition: "版本",
            user_count: "购买用户数",
            year: "购买时长",
          };
          this.rowDetail[0] = row;
          break;
        case "模块":
          let time = null;
          if (row.module_auth) {
            time = row.module_auth.expire_time;
            if (time != "买断") {
              time =
                new Date(row.module_auth.expire_time).getFullYear() -
                new Date(row.module_auth.create_time).getFullYear() +
                "年";
            }
            row.module_auth.show_exprie_time = time
          }

          // item.show_exprie_time = time;
          this.rowDetailConfig = {
            auth_code: "授权码",
            module_name: "模块",
            auth_name: "客户名称",
            show_exprie_time: "购买时长",
          };
          this.rowDetail[0] = row.module_auth;
          break;
        default:
          flag = false;
          break;
      }
      // this.loading = false
      this.rowDetailDialog = flag;
      // }).catch(()=>{
      // 	this.loading = false
      // })
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getOrderData();
    },
    handleSizeChange(val) {
      if (val <= this.pagination.total) {
        this.pagination.size = val;
        this.getOrderData();
      }
    },
    getOrderData() {
      this.loading = true;
      let params = {
        p: this.pagination.currentPage,
        count: this.pagination.size,
        date_start: this.selectOrderDateStart,
        date_stop: this.selectOrderDateEnd,
        auth_code: this.authCode,
        name: this.custom_name,
        code: this.order_code,
        product: this.product
      };
      let result = createGetUrlParams(params);

      if (result.success) {
        this.getOrderDataByParam(result.data);
      }
    },

    getOrderDataByParam(p) {
      getOrderByParam(p)
        .then((response) => {
          this.loading = false;
          this.pagination.total = response.count | 0;
          let tableData = response.results;
          console.log(response);

          tableData = tableData.map((item) => {

            if (item.product === "套件") {
              if (item.suit_auth) {
                item.detail_name = item.suit_auth.suit_name;
                let time = item.suit_auth.expire_time;
                if (time != "买断") {
                  time =
                    new Date(item.suit_auth.expire_time).getFullYear() -
                    new Date(item.suit_auth.create_time).getFullYear() +
                    "年";
                }
                item.show_exprie_time = time;
              }
            } else if (item.product === "FastBI") {
              item.show_exprie_time = item.months / 12;
              item.show_exprie_time =
                item.show_exprie_time >= 100
                  ? "买断"
                  : item.show_exprie_time + "年";
              item.detail_name = item.auth.edition;
            } else if (item.product === "模块") {
              if (item.module_auth) {
                let time = item.module_auth.expire_time;
                if (time != "买断") {
                  time =
                    new Date(item.module_auth.expire_time).getFullYear() -
                    new Date(item.module_auth.create_time).getFullYear() +
                    "年";
                }
                item.show_exprie_time = time;
                item.detail_name = item.module_auth.module_name;
              }
            } else if (item.product === "安捷云") {
              let time = null;
              if (item.afsaasmodule_auth) {
                item.detail_name = item.afsaasmodule_auth.module_name;
                if (item.afsaasmodule_auth.expire_time == "买断") {
                  time = "买断"
                } else {
                  time = new Date(item.afsaasmodule_auth.expire_time).getFullYear() -
                    new Date(item.afsaasmodule_auth.create_time).getFullYear() +
                    "年";
                }

              } else if (item.afapp_auth) {
                item.detail_name = item.afapp_auth.app_name
                if (item.afapp_auth.expire_time == "买断") {
                  time = "买断";
                } else {
                  time = new Date(item.afapp_auth.expire_time).getFullYear() -
                    new Date(item.afapp_auth.create_time).getFullYear() +
                    "年";
                }

              }
              item.show_exprie_time = time;
            } else if (item.product === "AF本地应用") {
              if (item.afapp_auth) {
                if (item.afapp_auth.expire_time == "买断") {
                  item.show_exprie_time = "买断";
                } else {
                  item.detail_name = item.afapp_auth.app_name
                  item.show_exprie_time = new Date(item.afapp_auth.expire_time).getFullYear() -
                    new Date(item.afapp_auth.create_time).getFullYear() +
                    "年";
                }

              }
            }
            return item;
          });
          this.tableData = tableData;
          console.log(this.tableData);

        })
        .catch((err) => {
          console.log(err);

          this.loading = false;
        });
    },

    search() {
      let params = {
        date_start: this.selectOrderDateStart,
        date_stop: this.selectOrderDateEnd,
        auth_code: this.authCode,
        name: this.custom_name,
        code: this.order_code,
        product: this.product
      };
      let result = createGetUrlParams(params);

      if (result.success) {
        this.loading = true;
        this.getOrderDataByParam(result.data);
        this.restPage(true);
      }
    },
    resetSearch() {
      this.restPage(true);
      this.selectOrderDateStart = "";
      this.selectOrderDateEnd = "";
      this.authCode = "";
      this.custom_name = "";
      this.order_code = ""
      this.product = ""
      this.getOrderData();
    },
    restPage(isUsePagination) {
      this.pagination.use = isUsePagination;
      this.pagination.currentPage = 1;
      this.pagination.size = 20;
    },
  },
};
</script>

<style lang="scss">
/*筛选部分start*/
.myOrder {
  .main {
    display: flex;
    flex-direction: column;
    margin: 0px 14px;
    height: 100%;
    //background-color: #FFFFFF;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    .main_title {
      margin: 15px 0;
    }

    .myOrder-main-list {
      flex-grow: 1;
    }
  }
}

.myOrder1-selector {
  padding: 18px 0px 20px 24px !important;
  min-width: 980px !important;
  font-size: 12px !important;
  background: #fff;

  .select-item {
    float: left !important;
    margin-right: 34px !important;
    padding: 8px 0px 8px 0px;
  }
  .selcet-product .el-input__inner {
    width: 150px;
    height: 32px;
  }

  .select-item .el-date-editor {
    width: 180px !important;
  }

  .select-item .el-input__inner {
    padding-right: 0px !important;
  }

  .select-item p {
    padding-right: 10px !important;
    float: left !important;
    height: 32px !important;
    line-height: 32px !important;
    text-align: right !important;
  }
}



.select-input {
  float: left !important;
  width: 180px !important;
}

.selcet-myOrder .el-input__inner {
  width: 150px !important;
  height: 32px !important;
  line-height: 32px !important;
}

.el-select-dropdown__list {
  padding: 6px 0px 22px 0px !important;
}

.el-select-dropdown span {
  font-size: 12px !important;
}

/*筛选部分end*/

.myOrder-main-line {
  width: 100% !important;
  border-bottom: 1px solid #ededed !important;
}

/*订单列表start*/
.myOrder-main-list {
  min-width: 1100px !important;
  height: 430px;
  /*margin-top: 10px!important;*/
  /*margin:35px 30px 0px 30px!important;*/
}

.myOrder-main-list .cell span {
  font-size: 12px !important;
}

/*订单列表end*/
</style>



// WEBPACK FOOTER //
// src/components/order/myOrder.vue